import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { autobind } from 'core-decorators'

import Icon from './Icon'

export default class WorkflowTools extends Component {

  static propTypes = {
    isDirty: PropTypes.bool,
    label: PropTypes.string,
    message: PropTypes.string,
    name: PropTypes.string,
    onChange: PropTypes.func
  }

  static getMessageFieldName(fieldName) {
    return `_message.${fieldName}`
  }

  componentDidUpdate(prevProps) {
    if (prevProps.message === undefined && this.props.message !== undefined) {
      // wait for the render cycle, then focus the textfield
      window.setTimeout(() => {
        this.rejectTextAreaRef.focus()
      }, 1)
    }
  }

  @autobind
  handleReject(e) {

    e.preventDefault()
    e.stopPropagation()

    const { name, message } = this.props
    let value = e.target.value

    if (!value && e.currentTarget.tagName === 'BUTTON') {
      // if we dont's have a message
      value = message === undefined
      // then the element becomes activated, so set the empty string as value
        ? ''
        // otherwise set the value to undefined
        : undefined
    }

    this.props.onChange({
      target: {
        name: WorkflowTools.getMessageFieldName(name),
        label: this.props.label,
        value
      }
    })

  }

  render() {

    const { name, label, message } = this.props

    const rejectionFormOpen = message !== undefined

    return (
      <div>
        <span className="tools reject-field-tools">

          {/* data-action needed for css */}
          <button
            type="button"
            className="btn btn-link reject-field"
            onClick={this.handleReject}
          // disabled={rejectionFormOpen}
          >
            <Icon name="cancel" />
          </button>

        </span>

        {rejectionFormOpen
          ? (
            <div className="form-group reject-form">
              <label
                htmlFor={WorkflowTools.getMessageFieldName(name)}
                className="control-label"
              >
                Ablehnungsgrund für
                {' '}
                {label}
                :
              </label>
              <div>
                <textarea rows="2"
                  ref={(ref) => {
                    this.rejectTextAreaRef = ref
                    return ref
                  }}
                  name={WorkflowTools.getMessageFieldName(name)}
                  className="form-control reject-message"
                  id={WorkflowTools.getMessageFieldName(name)}
                  // we cannot use autoFocus here, as that would steal focus on
                  // each re-render
                  value={message}
                  onChange={this.handleRejectionMessageChange}
                />
              </div>
            </div>
          )
          : null}
      </div>
    )
  }
}

// @autobind
// handleAccept(e) {
//   e.preventDefault()
//   e.stopPropagation()
//   const { name } = this.props
//   this.setState({
//     rejectionFormOpen: false
//   })
//   this.props.onChange({
//     target: {
//       name: `_message.${name}`,
//       value: null
//     }
//   })
// }

// {/* data-action needed for css */}
// <button
//   type="button"
//   className="btn btn-link accept-field"
//   onClick={this.handleAccept}
//   disabled={!rejectionFormOpen && rejectionFormOpen !== null}
// >
//   <Icon name="ok" />
// </button>



// WEBPACK FOOTER //
// ./src/shared/components/WorkflowTools.js